import { useMutation } from "@shared/lib/hooks";
import { BackednResponse } from "@shared/lib/types";
import {
  IAdRightsRequest,
  IBrandOrganisation,
} from "@shared/lib/types/brandOrganisation";
import { ORGANISATION_LIST_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export default function useEditAdRightSettings() {
  const {
    mutate: editAdRightSettings,
    isLoading: isEditAdRightSettingsLoading,
    isSuccess: isEditAdRightSettingsSuccess,
    error: editAdRightSettingsError,
  } = useMutation({
    mutationFn: (payload: IAdRightsRequest) =>
      OrganisationService.editAdRightSettings(payload),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, params) => {
      c.setQueryData(
        [...ORGANISATION_LIST_QUERY_KEY, params.brandOrganisationId],
        (oldData: BackednResponse<IBrandOrganisation>) => ({
          ...oldData,
          data: {
            ...oldData?.data,
            adRightsSettings: {
              ...oldData?.data?.adRightsSettings,
              ...data.data?.adRightsSettings,
            },
          },
        })
      );
    },
  });

  return {
    editAdRightSettings,
    isEditAdRightSettingsLoading,
    editAdRightSettingsError,
    isEditAdRightSettingsSuccess,
  };
}
